module.exports = __webpack_public_path__ + "img/k3s.01e2b406.svg";